import React from 'react';
import styles from './Service.module.scss';
import {$t} from "../../../helpers/translator";
import ErrorsTable from "../../../components/ErrorsTable/ErrorsTable";
import ErrorsGraph from "../../../components/ErrorsGraph/ErrorsGraph";
import ServiceCallsTable from "../../../components/ServiceCallsTable/ServiceCallsTable";


class ClinicService extends React.Component {
    constructor(props) {
        super(props);
    }



    render() {
        return (
            <div className={styles.container}>
                <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <ServiceCallsTable userType={2} header={$t('global.service.ServiceCalls')}/>
                    </div>
                </div>

                <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <ErrorsTable userType={2} header={$t('global.service.clinicPlatformErrors')}/>
                    </div>
                </div>

                <div className={styles['flex-row']}>
                    <div className={styles['box']}>
                        <ErrorsGraph userType={2} header={$t('global.service.clinicPlatformErrorsGraph')}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default ClinicService;
